var $ = require('jquery');

let youtube_iframes = Array.prototype.slice.call( document.querySelectorAll('.video iframe[src*="youtube.com"]') );
let ytplayerList = [];


window.onYouTubeIframeAPIReady_video_js = function () {

	initYoutubePlayers();

	// Add click listener to the "Play Me" buttons that overlay the video embeds. They should hide the button, hide the image overlay, and play the underlying video embed.
	$('.js-video__play').click( ali_onclick_video_play );

}




function onPlayerReady(e) {
	// console.log('%%%%%%%%%%%%%%%%');
	// console.log('onPlayerReady()', e);
	// console.log('%%%%%%%%%%%%%%%%');

	try {

		// When a YouTube iframe is ready, enable the custom play button (if a cover is being used)...
		let embed_node = e.target.getIframe();
		let embed_container = embed_node.parentNode.parentNode;

		let disabled_button = embed_container.querySelector('.js-video__play[disabled]');
		if( disabled_button ){
			disabled_button.disabled = false;
		}

		// ... and add a class to the embed container that will hide the loading animation.
		embed_container.classList.add('video__embed-container--iframe-ready');

	} catch (error) {
		console.log('Error in onPlayerReady()', error, e );
	}


}

function onPlayerError(e) {
		console.log('onPlayerError:', e);
}

function onPlayerStateChange(e) {

		var label = e.target.ulabel;
		if (e["data"] == YT.PlayerState.PLAYING) {
				// if one video is playing then pause the others
				pauseOtherYoutubes(e.target);
		}
		if (e["data"] == YT.PlayerState.PAUSED) {
				// console.log({
				// 		event: "youtube",
				// 		action: "pause:"+e.target.getPlaybackQuality(),
				// 		label: label
				// });
		}
		if (e["data"] == YT.PlayerState.ENDED) {
				// console.log({
				// 		event: "youtube",
				// 		action: "end",
				// 		label: label
				// });
		}
		if (e["data"] == YT.PlayerState.BUFFERING) {
				// console.log({
				// 		event: "youtube",
				// 		action: "buffering["+e.target.uBufferingCount+"]:"+e.target.getPlaybackQuality(),
				// 		label: label
				// });
				// If one video is playing then pause the others. This is needed because at start video is in buffered state and will start playing without going to playing state.
				if( YT.PlayerState.UNSTARTED ==  e.target.uLastPlayerState ){
						pauseOtherYoutubes(e.target);
				}
		}
		//last action keep stage in uLastPlayerState
		if( e.data != e.target.uLastPlayerState ) {
				// console.log(label + ":state change from " + e.target.uLastPlayerState + " to " + e.data);
				e.target.uLastPlayerState = e.data;
		}
}

function pauseOtherYoutubes( currentPlayer ) {
		if (!currentPlayer) return;
		try {
			for (var i = ytplayerList.length; i-- ;){
				if( ytplayerList[i] && (ytplayerList[i] != currentPlayer) ){
						ytplayerList[i].pauseVideo();
				}
		}
		} catch (error) {
			console.log('Error in pauseOtherYoutubes()', error, currentPlayer );
		}

}

function pauseAllYoutubes() {
	try {
		for (var i = ytplayerList.length; i-- ;){
			if( ytplayerList[i] ){
					ytplayerList[i].pauseVideo();
			}
		}
	} catch (error) {
		console.log('Error in pauseAllYoutubes()', error );
	}

}

function initYoutubePlayers(){
	try {

		for( let i=0; i<youtube_iframes.length; i++ ){
			ytplayerList.push(initYoutubePlayer( youtube_iframes[i] ));
			// console.log("create a Youtube player successfully", youtube_iframes[i]);
		}

	} catch (error) {
		console.log('Error in initYoutubePlayers()', error );
	}

}

//init a youtube iframe
function initYoutubePlayer(ytiframe){
	try {

		var ytp = new YT.Player(ytiframe, {
			events: {
					onStateChange: onPlayerStateChange,
					onError: onPlayerError,
					onReady: onPlayerReady
			}
		});
		ytiframe.ytp = ytp;
		return ytp;

	} catch (error) {
		console.log('Error in initYoutubePlayer()', error );
	}

}

function ali_play_video( target ){
	try {
		target.playVideo();

	} catch (error) {
		console.log( 'Error playing youtube video:', error );
	}

}




// Add click listener to the "Play Me" buttons that overlay the video embeds. They should hide the button, hide the image overlay, and play the underlying video embed.
$('.js-video__play').click( ali_onclick_video_play );

function ali_onclick_video_play(e){

	try {

		var this_button = $(this);

		var iframes = this_button.siblings('.iframe-container').children('iframe');
		let iframe = iframes[0];
		// console.log('Clicked on play button for this iframe:', iframe );

		this_button.parents('.video__embed-container').addClass('video__embed-container--view-video');
		this_button.attr('disabled', 'disabled');

		if( iframe.src.indexOf('youtube.com') > -1 ){

			// Play the youtube video in the iframe.
			for( let counter=0; counter<ytplayerList.length; counter++ ){
				(function (counter){
					if( iframe == ytplayerList[counter].i ){
						ali_play_video( ytplayerList[counter] );
					}
				}(counter));
			}

		} else if( iframe.src.indexOf('vimeo.com') > -1 ){
			// Something else for vimeo to autoplay.
			var autoplay_string = iframe.src.indexOf('autoplay');

			if( autoplay_string > -1 ){
				iframe.setAttribute('src', iframe.src.replace('autoplay=0', 'autoplay=1') );

			} else {

				if( iframe.src.indexOf('?') > -1 ){
					iframe.setAttribute( 'src', iframe.src+'&autoplay=1' );

				} else {
					iframe.setAttribute( 'src', iframe.src+'?autoplay=1' );
				}

			}

		}

	}
	catch(error){
		console.log('Error autoplaying video embed:');
		console.log(error);
	}
}





// The video sliders use the Splide library.
// https://splidejs.com/
const video_sliders = [];
const pagers = document.getElementsByClassName( 'video__pager-splide' );
const sliders = document.getElementsByClassName( 'video__splide' );

document.addEventListener('DOMContentLoaded', function() {
	try {

		for ( let i = 0, len = pagers.length; i < len; i++ ) {

			// Each slider consist of its pager and the actual video slider.
			video_sliders[i] = {
				pager: null,
				slider: null
			}

			// Set the pager first...
			video_sliders[i].pager = new Splide( pagers[ i ], {
				pagination: false,
				perMove: 1,
				perPage: 5,
				// start: pagers[i].querySelectorAll('.video__pager-slide').length - 1,
				type: 'slide',//'loop',
				gap: '1.6rem',
				isNavigation: true,
				updateOnMove: true,
				// arrowPath: 'M7.5.5L12 5 7.5 9.5 6.086 8.086 8.171 6H0V4h8.171L6.086 1.914z',
				arrowPath: 'M21.5 15l4.5 4.5-4.5 4.5-1.414-1.414 2.085-2.086H14v-2h8.171l-2.085-2.086z',
				padding: {
					left: 'calc((((100vw - 11.25vw - 3rem) - 1390px) / 2) + 78px)',
					right: 100
				},
				classes: {
					arrows: 'splide__arrows video__pager-arrows'
				},
				// NOTE - each breakpoint needs a padding property, even if it reuses the previous breakpoint's padding. If you don't explicitly state the padding it will act like you entered 0.
				breakpoints: {
					1560: {
						padding: {
							left: 48,
							right: 100
						}
					},
					1200: {
						perPage: 4,
						padding: {
							left: 48,
							right: 100
						}
					},
					1000: {
						padding: {
							left: 32,
							right: 100
						}
					},
					960: {
						perPage: 3,
						padding: {
							left: 32,
							right: 100
						}
					},
					640: {
						perPage: 2,
						padding: {
							left: 32,
							right: 100
						}
					},
					400: {
						perPage: 1,
						padding: {
							left: 32,
							right: 100
						}
					},
				}
			} );

			// ... then set the actual slider next so that it can be synced with the pager.
			video_sliders[i].slider = new Splide( sliders[ i ], {
				pagination: false,
				arrows: false,
				type: 'loop',
				perPage: 1,
				// start: sliders[i].querySelectorAll('.video__slide').length - 1,
			} ).sync( video_sliders[i].pager );

			video_sliders[i].slider.on( 'move', function ( Slide ) {
				pauseAllYoutubes();
			} );

			// Initialize the sliders/pagers.
			video_sliders[i].pager.mount();
			video_sliders[i].slider.mount();
		}

	}
	catch(error){
		console.log('Error starting the video carousel(s):');
		console.log(error);
	}

}, false );



// On smaller screens, scroll to the video/content area after clicking on a pager thumbnail. Otherwise the main slider can move while being offscreen and the user would not know that they are using the pager to control the main slider.
try {

	const video_pager_slides = Array.prototype.slice.call( document.querySelectorAll('.video__pager-slide') );

	document.addEventListener('DOMContentLoaded', function() {

		for( let i=0; i < video_pager_slides.length; i++ ){
			video_pager_slides[i].addEventListener( 'click', (e) => {
				// console.log(e.target);

				if( window.innerWidth < 600 ){
					let parent_carousel = e.target;
					do {
						parent_carousel = parent_carousel.parentNode;
					}
					while( !parent_carousel.classList.contains('videos--carousel') && parent_carousel !== document.body );

					if( parent_carousel.classList.contains('videos--carousel') ){
						// window.scrollTo({
						// 	left: 0,
						// 	top: parent_carousel.getBoundingClientRect().top + window.pageYOffset - 50,
						// 	behavior: 'smooth'
						// });

						setTimeout( () => {
							parent_carousel.scrollIntoView({
								behavior: 'smooth',
								block: 'start'
							});
						}, 10)

					}
				}

			});
		}

	}, false );

}
catch(error){
	console.log('Error setting click listener for video pager slides:');
	console.log(error);
}
